import React, { useEffect } from 'react'
import { GetActualiteById } from './Admin/Main/services';
import './styles.css'

export default function Actuality() {

    useEffect(() => {
        const queryString = window.location.href;
        var id = queryString.match(/\/(\d+)$/)[1];

        GetActualiteById(id).then(source => console.log(source))
    }, [])
    
  return (
    <div>Actuality</div>
  )
}
